import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useOnElementWidthChange } from '../../../../../hooks/use-on-element-width-change';
import { ReturnDetailsGridLayout } from '../return-details-grid-layout';

import style from './resize-observer-layout.module.less';

const TWO_COLUMN_BREAKPOINT = 552;
const ONE_COLUMN_BREAKPOINT = 390;

const columnCountToClassNameMap = {
  1: style['one-column'],
  2: style['two-columns'],
  3: style['three-columns'],
};

export const LayoutContainer = ({ addressColumnContent, dateColumnContent, rmaColumnContent }) => {
  const [columnCount, setColumnCount] = useState(3);
  const [isContainerLoaded, setIsContainerLoaded] = useState(false);

  const containerRef = useRef(null);

  const updateLayout = useCallback((width) => {
    if (width <= ONE_COLUMN_BREAKPOINT) {
      setColumnCount(1);
    } else if (width <= TWO_COLUMN_BREAKPOINT) {
      setColumnCount(2);
    } else {
      setColumnCount(3);
    }
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current) {
      updateLayout(containerRef.current?.offsetWidth);
      setIsContainerLoaded(true);
    }
  }, [updateLayout]);

  useOnElementWidthChange(containerRef, updateLayout);

  return (
    <div ref={containerRef}>
      {isContainerLoaded ? (
        <ReturnDetailsGridLayout
          addressColumnContent={addressColumnContent}
          className={classnames(style['return-details-grid'], columnCountToClassNameMap[columnCount])}
          dateColumnContent={dateColumnContent}
          rmaColumnContent={rmaColumnContent}
        />
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

LayoutContainer.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  dateColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
};
